/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ClassicInputs */

const cs_enum_classic = /** @type {(inputs: Enum_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klasický`)
};

const en_enum_classic = /** @type {(inputs: Enum_ClassicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classic`)
};

/**
* | output |
* | --- |
* | "Classic" |
*
* @param {Enum_ClassicInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_classic = /** @type {((inputs?: Enum_ClassicInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ClassicInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_classic(inputs)
	return cs_enum_classic(inputs)
});